export default "__VITE_ASSET__DbLbiYTb__"